export default () => {
  // Enregistrement du service worker
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/service-worker")
      .then(() => console.log("[ServiceWorker] Service Worker registered:"))
      .catch((error) => console.log("[ServiceWorker] Error Service Worker:", error));
  }
};
